import template from './sick_leave_cycles_information_help.html';
import * as Utils from '../../../lib/savanna_utils.js';

class SickLeaveCyclesInformationHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class SickLeaveCyclesInformationHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new SickLeaveCyclesInformationHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'SickLeaveCyclesInformationHelp',
	dialog_class: SickLeaveCyclesInformationHelpPage,
	template: template,
	template_filename: 'translation/dialogs/sick_leave_cycles_information_help',
	provider: 'ps'
};
